export default "__VITE_ASSET__3alq_bEe__"